// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2-Jao","dragIcon":"Choice_dragIcon__hLLYn","left":"Choice_left__2v_Qs","input":"Choice_input__1WvVa"};